/* eslint-disable react-native/no-raw-text */
import React from 'react';
import { COLORS, FONTS, FONT_SIZES } from '@bcm/constants';
import { View, Text, StyleSheet, Image } from 'react-native';
import { useSelector } from 'react-redux';

const Story = () => {

	const isLandscape = useSelector( state => state.globals.isLandscape);

	const styles = StyleSheet.create({
		container: {
			height: isLandscape ? '70vh' : undefined,
			minHeight: isLandscape ? 500 : undefined,
			width: '100%',
			padding: !isLandscape ? 20 :'15vw',
			justifyContent: 'center',
			alignItems: 'center',
			backgroundColor: COLORS.white,
		},
		textHeaderContainer: {
			width: !isLandscape ? '100%' :'70vw',
			padding: 10,
			borderRadius: 10,
			justifyContent: 'center',
			alignItems: 'center',
		},
		textHeader: {
			fontFamily: FONTS.default,
			fontSize: 30,
		},
		storiesContainer: {
			flexDirection: !isLandscape ? 'column' : 'row',
		},
		storyContainer: {
			marginVertical: 10,
			marginHorizontal: isLandscape ? 20 : 0,
			height: isLandscape ? 300 : 260,
			width: isLandscape ? 240 : '100%',
			backgroundColor: COLORS.white,
			justifyContent: 'center',
			alignItems: 'center',
		},
		storyImageContainer: {
			height: 160,
			width: 240,
		},
		storyHeaderText: {
			fontFamily: FONTS.bold,
			fontSize: 30,
			color: COLORS.primary,
			borderBottomWidth: 2,
		},
		highlightText: {
			fontFamily: FONTS.default,
			color: COLORS.primary,
		},
		storyText: {
			fontFamily: FONTS.default,
			fontSize: FONT_SIZES.lg,
			color: COLORS.primary,
		},
	});

	return (
		<View style={styles.container}>
			{isLandscape && <View style={styles.textHeaderContainer}>
				<Text style={styles.textHeader}>
					<Text style={styles.highlightText}>{'50%'}</Text>
					{' of burn patients receive '}
					<Text style={styles.highlightText}>{'inaccurate'}</Text>
					{' initial evaluations'}
				</Text>
				<Text style={styles.textHeader}>
					{'Clunky documentation tools '}
					<Text style={styles.highlightText}>{'drain provider\'s time'}</Text>
				</Text>
				<Text style={styles.textHeader}>
					{'On discharge, patients face '}
					<Text style={styles.highlightText}>{'long travel times'}</Text>
					{' for care'}
				</Text>
			</View>}
			<View style={styles.storiesContainer}>
				{/* Triage */}
				{!isLandscape && <Text style={styles.textHeader}>
					<Text style={styles.highlightText}>{'50%'}</Text>
					{' of burn patient\'s receive '}
					<Text style={styles.highlightText}>{'inaccurate'}</Text>
					{' initial evaluations'}
				</Text>}
				<View style={styles.storyContainer}>
					<Image
						source={require('../../assets/images/icons/triage.png')}
						style={styles.storyImageContainer}
					/>
					<Text style={styles.storyHeaderText}>Triage</Text>
					<Text style={styles.storyText}>Local Emergency Room</Text>
				</View>
				{/* Monitor */}
				{!isLandscape && <Text style={styles.textHeader}>
					{'Clunky documentation tools '}
					<Text style={styles.highlightText}>{'drain provider\'s time'}</Text>
				</Text>}
				<View style={styles.storyContainer}>
					<Image
						source={require('../../assets/images/icons/monitor.png')}
						style={styles.storyImageContainer}
					/>
					<Text style={styles.storyHeaderText}>Monitoring</Text>
					<Text style={styles.storyText}>Track Wound Evaluation</Text>
				</View>
				{/* Follow Up */}
				{!isLandscape && <Text style={styles.textHeader}>
					{'On discharge, patients face '}
					<Text style={styles.highlightText}>{'long travel times'}</Text>
					{' for care'}
				</Text>}
				<View style={styles.storyContainer}>
					<Image
						source={require('../../assets/images/icons/home.png')}
						style={styles.storyImageContainer}
					/>
					<Text style={styles.storyHeaderText}>Follow Up</Text>
					<Text style={styles.storyText}>Recovery & Rehabilitation</Text>
				</View>
			</View>
		</View>
	);
};

export default Story;